!(function () {
  "use strict";
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  !(function () {
    var e = "data-section-id";
    function t(t, o) {
      (this.container = (function (t) {
        if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
        if (null === t.getAttribute(e)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the data-section-id attribute.");
        return t;
      })(t)),
        (this.id = t.getAttribute(e)),
        (this.extensions = []),
        Object.assign(
          this,
          (function (e) {
            if ((void 0 !== e && "object" != typeof e) || null === e) throw new TypeError("Theme Sections: The properties object provided is not a valid");
            return e;
          })(o)
        ),
        this.onLoad();
    }
    (t.prototype = {
      onLoad: Function.prototype,
      onUnload: Function.prototype,
      onSelect: Function.prototype,
      onDeselect: Function.prototype,
      onBlockSelect: Function.prototype,
      onBlockDeselect: Function.prototype,
      extend: function (e) {
        this.extensions.push(e);
        var t = Object.assign({}, e);
        delete t.init, Object.assign(this, t), "function" == typeof e.init && e.init.apply(this);
      },
    }),
      "function" != typeof Object.assign &&
        Object.defineProperty(Object, "assign", {
          value: function (e) {
            if (null == e) throw new TypeError("Cannot convert undefined or null to object");
            for (var t = Object(e), o = 1; o < arguments.length; o++) {
              var n = arguments[o];
              if (null != n) for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
            }
            return t;
          },
          writable: !0,
          configurable: !0,
        });
    var o = "data-section-type";
    (window.Shopify = window.Shopify || {}), (window.Shopify.theme = window.Shopify.theme || {}), (window.Shopify.theme.sections = window.Shopify.theme.sections || {});
    var n = (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
      r = (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    function i(e) {
      var t = [];
      if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var o = e[0];
      return (
        e instanceof Element || o instanceof Element
          ? u(e).forEach(function (e) {
              t = t.concat(
                r.filter(function (t) {
                  return t.container === e;
                })
              );
            })
          : ("string" != typeof e && "string" != typeof o) ||
            d(e).forEach(function (e) {
              t = t.concat(
                r.filter(function (t) {
                  return t.type === e;
                })
              );
            }),
        t
      );
    }
    function c(e) {
      for (var t, o = 0; o < r.length; o++)
        if (r[o].id === e) {
          t = r[o];
          break;
        }
      return t;
    }
    function d(e) {
      return (
        "*" === e
          ? (e = Object.keys(n))
          : "string" == typeof e
          ? (e = [e])
          : e.constructor === t
          ? (e = [e.prototype.type])
          : Array.isArray(e) &&
            e[0].constructor === t &&
            (e = e.map(function (e) {
              return e.prototype.type;
            })),
        e.map(function (e) {
          return e.toLowerCase();
        })
      );
    }
    function u(e) {
      return (
        NodeList.prototype.isPrototypeOf(e) && e.length > 0 ? (e = Array.prototype.slice.call(e)) : (NodeList.prototype.isPrototypeOf(e) && 0 === e.length) || null === e ? (e = []) : !Array.isArray(e) && e instanceof Element && (e = [e]), e
      );
    }
    window.Shopify.designMode &&
      (document.addEventListener("shopify:section:load", function (e) {
        var t,
          c,
          s = e.detail.sectionId,
          a = e.target.querySelector('[data-section-id="' + s + '"]');
        null !== a &&
          ((t = a.getAttribute(o)),
          (c = a),
          (t = d(t)),
          void 0 === c && (c = document.querySelectorAll("[data-section-type]")),
          (c = u(c)),
          t.forEach(function (e) {
            var t = n[e];
            void 0 !== t &&
              (c = c.filter(function (n) {
                return !(i(n).length > 0 || null === n.getAttribute(o) || (n.getAttribute(o) === e && (r.push(new t(n)), 1)));
              }));
          }));
      }),
      document.addEventListener("shopify:section:unload", function (e) {
        var t = e.detail.sectionId,
          o = e.target.querySelector('[data-section-id="' + t + '"]');
        "object" == typeof i(o)[0] &&
          i(o).forEach(function (e) {
            var t = r
              .map(function (e) {
                return e.id;
              })
              .indexOf(e.id);
            r.splice(t, 1), e.onUnload();
          });
      }),
      document.addEventListener("shopify:section:select", function (e) {
        var t = c(e.detail.sectionId);
        "object" == typeof t && t.onSelect(e);
      }),
      document.addEventListener("shopify:section:deselect", function (e) {
        var t = c(e.detail.sectionId);
        "object" == typeof t && t.onDeselect(e);
      }),
      document.addEventListener("shopify:block:select", function (e) {
        var t = c(e.detail.sectionId);
        "object" == typeof t && t.onBlockSelect(e);
      }),
      document.addEventListener("shopify:block:deselect", function (e) {
        var t = c(e.detail.sectionId);
        "object" == typeof t && t.onBlockDeselect(e);
      }));
    const s = "product-details";
    if (s in Shopify.theme.sections.registered)
      document.querySelectorAll(`[data-section-type=${s}]`).forEach((e, t) => {
        if (0 !== t) {
          const t = e.querySelector("link"),
            o = e.querySelector("script");
          t.remove(), o.remove();
        }
      });
    else {
      const e = {
          container: ".productSection__images",
          containerNav: ".productSection__galleryNav",
          productWrapper: ".productSection__slider",
          productWrapperActiveClass: "productSection__slider--active",
          accTitles: ".productSection__accordionTitle",
          addButton: ".productSection__formButton",
          optionVariant: ".productSection .productIdSelect--js",
          rtlElem: "html[dir='rtl']",
          productJSON: "#productJSON",
          variantsAdditionalDataJSON: "[id^=VariantsAdditionalDataJSON-]",
          productForm: ".productSection__form",
          productVariantSelect: ".productSection__variantSelect",
          productFrequencyRadioGroup: ".productSection__frequencyRadioGroup",
          productFrequencyRadioMoney: ".productSection__money",
          productButtonMoney: ".productSection__formButtonWrapper .productSection__money",
          productCartButton: ".productSection__formButtonWrapper .productSection__formButton",
          productCartButtonText: ".productSection__formButtonWrapper .productSection__formButtonText",
          productFrequencyOption: ".productSection__frequencyOption",
          productSelectedVariantId: ".productSection__selectedVariantId",
          subscriptionLineItemInput: ".product-form__properties [name='properties[Subscription]']"
        },
        o = { infinite: !1, dots: !1, arrows: !1, slidesToShow: 1, slidesToScroll: 1, responsive: [{ breakpoint: 769, settings: { dots: !0 } }], rtl: !!document.querySelector(e.rtlElem) },
        r = { infinite: !1, dots: !1, arrows: !0, slidesToShow: 3, slidesToScroll: 1, asNavFor: ".slider-for", vertical: !0, focusOnSelect: !0 },
        i = (e, t, o) => {
          (t.innerText = o), e.setAttribute("disabled", ""), (e.style.opacity = "0.4"), e.querySelector("span").setAttribute("hidden", ""), (e.querySelector("svg").style.display = "none");
        },
        c = (e, t, o) => {
          (t.innerText = o), e.removeAttribute("disabled"), (e.style.opacity = "1"), (e.querySelector("svg").style.display = "block");
        },
        d = () => {
          const t = JSON.parse(document.querySelector(e.productJSON).innerHTML),
            n = document.querySelector(e.productForm),
            d = document.querySelector(e.productCartButton),
            u = document.querySelector(e.productCartButtonText),
            variantsAdditionalData = JSON.parse(document.querySelector(e.variantsAdditionalDataJSON).innerHTML);
          document.querySelectorAll(e.productFrequencyRadioGroup).length && i(d, u, window.theme.strings.selectFrequency),
            n.addEventListener("change", () => {
              const o = document.querySelector(e.productVariantSelect).value;
              let n;
              if (
                (document.querySelectorAll(e.productFrequencyOption).forEach((t) => {
                  const o = t.closest(e.productFrequencyRadioGroup);
                  o.classList.remove("checked"), t.checked && ((n = t.value), o.classList.add("checked"));
                }),
                o)
              ) {
                debugger;
                const n = t.variants.findIndex((e) => e.options.includes(o)),
                  r = t.variants[n];
                 if (r){
                   // debugger;
                    if(r.available){
                      d.disabled = false;
                      u.textContent = window.theme.strings.addToCart; 
                    }
                    else{
                      d.disabled = true;
                      u.textContent = window.theme.strings.productSoldOut;
                    }
                  }
                document.querySelectorAll(e.productButtonMoney).forEach((e) => {
                  e.setAttribute("hidden", "");
                }),
                  document.querySelector(`${e.productButtonMoney}[value="${r.id}"]`).removeAttribute("hidden"),
                  (document.querySelector(e.productSelectedVariantId).value = r.id);
              }
              if (o && n) {
                const r = t.variants.findIndex((e) => e.options.includes(o) && e.options.includes(n)),
                  s = t.variants[r],
                  variantAdditionalData = variantsAdditionalData.data.find(x => x.id === s.id);
                
                document.querySelectorAll(e.productFrequencyOption).forEach((t) => {
                  const o = t.closest(e.productFrequencyRadioGroup);
                  o.querySelectorAll(e.productFrequencyRadioMoney).forEach((e) => {
                    e.setAttribute("hidden", "");
                  }),
                    t.checked && o.querySelector(`${e.productFrequencyRadioMoney}[value="${s.id}"]`).removeAttribute("hidden");
                }),
                  document.querySelectorAll(e.productButtonMoney).forEach((e) => {
                    e.setAttribute("hidden", "");
                  }),
                  document.querySelector(`${e.productButtonMoney}[value="${s.id}"]`).removeAttribute("hidden"),
                  (document.querySelector(e.productSelectedVariantId).value = s.id),
                  s.available ? c(d, u, window.theme.strings.addToCart) : i(d, u, window.theme.strings.productSoldOut);

                  if (variantAdditionalData?.metafields?.custom?.subscription === true) {
                    const subscriptionLineItemInput = document.querySelector(e.subscriptionLineItemInput);
                    if (subscriptionLineItemInput) {
                      subscriptionLineItemInput.value = s.options[s.options.length - 1].split('-')[1] || 'Subscribe & Save 10%';
                    }
                  } else {
                    const subscriptionLineItemInput = document.querySelector(e.subscriptionLineItemInput);
                    if (subscriptionLineItemInput) {
                      subscriptionLineItemInput.value = "";
                    }
                  }
              }
            });
          const s = document.querySelectorAll(e.accTitles),
            a = document.querySelectorAll(e.addButton);
          $(e.container).slick(o),
            $(e.containerNav).slick(r);
            
            // The auto sliding
            setTimeout(() => {
              const selector = '.productSection__images--slider';
              const images = document.querySelectorAll(`${selector} img`);
              const imagesCount = images.length;
              let i = 1;
              const interval = setInterval(() => {
                console.log({ i, imagesCount })
                if (i >= imagesCount) {
                  $(selector).slick('slickGoTo', 0);
                  clearInterval(interval);
                }
                $(selector).slick('slickNext');
                i++;
              }, 1500);
            }, 1000);
          
            a.forEach((e) => {
              // e.addEventListener("click", (e) => {
              //   e.preventDefault(), addToCart();
              // });
              e.addEventListener("click", (t) => {
                t.preventDefault(), addToCart(e);
              });
            }),
            s.forEach((e) => {
              !(function (e) {
                e.addEventListener("click", (e) => {
                  const t = e.currentTarget.nextElementSibling;
                  t.classList.toggle("active"), t.classList.contains("active") ? (t.style.maxHeight = t.scrollHeight + "px") : (t.style.maxHeight = 0);
                });
              })(e);
            }),
            // (window.addToCart = async function () {
            //   const t = { items: [{ id: document.querySelector(e.productSelectedVariantId).value, quantity: 1 }] };
            //   (await fetch(window.Shopify.routes.root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(t) })).ok || console.error("Error:", error), window.theme.drawCart();
            // });
            (window.addToCart = async function (btn) {
              // debugger;
              let t = { items: [{ id: document.querySelector(e.productSelectedVariantId).value, quantity: 1 }] };
               
              const form = btn?.closest('form');
              if (form){
                // debugger;
                  const formData = new FormData(form); // Get form data
                  const cartLineItemProperties  = Array.from(formData.entries()).reduce(function(result, [name, value]) {
                    if (name.startsWith("properties[")) {
                      var propertyName = name.match(/\[(.*?)\]/)[1];
                      if (value) {
                        result[propertyName] = value;
                      }
                    }
                    return result;
                  }, {});
                t = {
                  items: [
                    {
                      id: document.querySelector(e.productSelectedVariantId).value,
                      quantity: 1,
                      properties: cartLineItemProperties
                    }
                  ]
                };
                
             } 
            (await fetch(window.Shopify.routes.root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(t) })).ok || console.error("Error:", error), window.theme.drawCart();
            
            });
        },
        u = () => {
          $(e.container).slick("unslick");
        };
      !(function (e, o) {
        if (void 0 !== n[e]) throw new Error('Theme Sections: A section of type "' + e + '" has already been registered. You cannot register the same section type twice');
        function r(e) {
          t.call(this, e, o);
        }
        (r.constructor = t), (r.prototype = Object.create(t.prototype)), (r.prototype.type = e), (n[e] = r);
      })(s, {
        async onLoad() {
          d();
        },
        onUnload() {
          u();
        },
      });
    }
  })();
})();


// !function(){"use strict";!function(){var e="data-section-id";function t(t,o){this.container=function(t){if(!(t instanceof Element))throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");if(null===t.getAttribute(e))throw new Error("Theme Sections: The section container provided does not have an id assigned to the data-section-id attribute.");return t}(t),this.id=t.getAttribute(e),this.extensions=[],Object.assign(this,function(e){if(void 0!==e&&"object"!=typeof e||null===e)throw new TypeError("Theme Sections: The properties object provided is not a valid");return e}(o)),this.onLoad()}t.prototype={onLoad:Function.prototype,onUnload:Function.prototype,onSelect:Function.prototype,onDeselect:Function.prototype,onBlockSelect:Function.prototype,onBlockDeselect:Function.prototype,extend:function(e){this.extensions.push(e);var t=Object.assign({},e);delete t.init,Object.assign(this,t),"function"==typeof e.init&&e.init.apply(this)}},"function"!=typeof Object.assign&&Object.defineProperty(Object,"assign",{value:function(e){if(null==e)throw new TypeError("Cannot convert undefined or null to object");for(var t=Object(e),o=1;o<arguments.length;o++){var n=arguments[o];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t},writable:!0,configurable:!0});var o="data-section-type";window.Shopify=window.Shopify||{},window.Shopify.theme=window.Shopify.theme||{},window.Shopify.theme.sections=window.Shopify.theme.sections||{};var n=window.Shopify.theme.sections.registered=window.Shopify.theme.sections.registered||{},r=window.Shopify.theme.sections.instances=window.Shopify.theme.sections.instances||[];function i(e){var t=[];if(NodeList.prototype.isPrototypeOf(e)||Array.isArray(e))var o=e[0];return e instanceof Element||o instanceof Element?u(e).forEach((function(e){t=t.concat(r.filter((function(t){return t.container===e})))})):"string"!=typeof e&&"string"!=typeof o||d(e).forEach((function(e){t=t.concat(r.filter((function(t){return t.type===e})))})),t}function c(e){for(var t,o=0;o<r.length;o++)if(r[o].id===e){t=r[o];break}return t}function d(e){return"*"===e?e=Object.keys(n):"string"==typeof e?e=[e]:e.constructor===t?e=[e.prototype.type]:Array.isArray(e)&&e[0].constructor===t&&(e=e.map((function(e){return e.prototype.type}))),e.map((function(e){return e.toLowerCase()}))}function u(e){return NodeList.prototype.isPrototypeOf(e)&&e.length>0?e=Array.prototype.slice.call(e):NodeList.prototype.isPrototypeOf(e)&&0===e.length||null===e?e=[]:!Array.isArray(e)&&e instanceof Element&&(e=[e]),e}window.Shopify.designMode&&(document.addEventListener("shopify:section:load",(function(e){var t,c,s=e.detail.sectionId,a=e.target.querySelector('[data-section-id="'+s+'"]');null!==a&&(t=a.getAttribute(o),c=a,t=d(t),void 0===c&&(c=document.querySelectorAll("[data-section-type]")),c=u(c),t.forEach((function(e){var t=n[e];void 0!==t&&(c=c.filter((function(n){return!(i(n).length>0||null===n.getAttribute(o)||n.getAttribute(o)===e&&(r.push(new t(n)),1))})))})))})),document.addEventListener("shopify:section:unload",(function(e){var t=e.detail.sectionId,o=e.target.querySelector('[data-section-id="'+t+'"]');"object"==typeof i(o)[0]&&i(o).forEach((function(e){var t=r.map((function(e){return e.id})).indexOf(e.id);r.splice(t,1),e.onUnload()}))})),document.addEventListener("shopify:section:select",(function(e){var t=c(e.detail.sectionId);"object"==typeof t&&t.onSelect(e)})),document.addEventListener("shopify:section:deselect",(function(e){var t=c(e.detail.sectionId);"object"==typeof t&&t.onDeselect(e)})),document.addEventListener("shopify:block:select",(function(e){var t=c(e.detail.sectionId);"object"==typeof t&&t.onBlockSelect(e)})),document.addEventListener("shopify:block:deselect",(function(e){var t=c(e.detail.sectionId);"object"==typeof t&&t.onBlockDeselect(e)})));const s="product-details";if(s in Shopify.theme.sections.registered)document.querySelectorAll(`[data-section-type=${s}]`).forEach(((e,t)=>{if(0!==t){const t=e.querySelector("link"),o=e.querySelector("script");t.remove(),o.remove()}}));else{const e={container:".productSection__images",containerNav:".productSection__galleryNav",productWrapper:".productSection__slider",productWrapperActiveClass:"productSection__slider--active",accTitles:".productSection__accordionTitle",addButton:".productSection__formButton",optionVariant:".productSection .productIdSelect--js",rtlElem:"html[dir='rtl']",productJSON:"#productJSON",productForm:".productSection__form",productVariantSelect:".productSection__variantSelect",productFrequencyRadioGroup:".productSection__frequencyRadioGroup",productFrequencyRadioMoney:".productSection__money",productButtonMoney:".productSection__formButtonWrapper .productSection__money",productCartButton:".productSection__formButtonWrapper .productSection__formButton",productCartButtonText:".productSection__formButtonWrapper .productSection__formButtonText",productFrequencyOption:".productSection__frequencyOption",productSelectedVariantId:".productSection__selectedVariantId"},o={infinite:!0,dots:!1,arrows:!1,slidesToShow:1,slidesToScroll:1,asNavFor:".slider-nav",responsive:[{breakpoint:769,settings:{dots:!0}}],rtl:!!document.querySelector(e.rtlElem)},r={infinite:!0,dots:!1,arrows:!0,slidesToShow:3,slidesToScroll:1,asNavFor:".slider-for",vertical:!0},i=(e,t,o)=>{t.innerText=o,e.setAttribute("disabled",""),e.style.opacity="0.4",e.querySelector("span").setAttribute("hidden",""),e.querySelector("svg").style.display="none"},c=(e,t,o)=>{t.innerText=o,e.removeAttribute("disabled"),e.style.opacity="1",e.querySelector("svg").style.display="block"},d=()=>{const t=JSON.parse(document.querySelector(e.productJSON).innerHTML),n=document.querySelector(e.productForm),d=document.querySelector(e.productCartButton),u=document.querySelector(e.productCartButtonText);document.querySelectorAll(e.productFrequencyRadioGroup).length&&i(d,u,window.theme.strings.selectFrequency),n.addEventListener("change",(()=>{const o=document.querySelector(e.productVariantSelect).value;let n;if(document.querySelectorAll(e.productFrequencyOption).forEach((t=>{const o=t.closest(e.productFrequencyRadioGroup);o.classList.remove("checked"),t.checked&&(n=t.value,o.classList.add("checked"))})),o){const n=t.variants.findIndex((e=>e.options.includes(o))),r=t.variants[n];document.querySelectorAll(e.productButtonMoney).forEach((e=>{e.setAttribute("hidden","")})),document.querySelector(`${e.productButtonMoney}[value="${r.id}"]`).removeAttribute("hidden"),document.querySelector(e.productSelectedVariantId).value=r.id}if(o&&n){const r=t.variants.findIndex((e=>e.options.includes(o)&&e.options.includes(n))),s=t.variants[r];document.querySelectorAll(e.productFrequencyOption).forEach((t=>{const o=t.closest(e.productFrequencyRadioGroup);o.querySelectorAll(e.productFrequencyRadioMoney).forEach((e=>{e.setAttribute("hidden","")})),t.checked&&o.querySelector(`${e.productFrequencyRadioMoney}[value="${s.id}"]`).removeAttribute("hidden")})),document.querySelectorAll(e.productButtonMoney).forEach((e=>{e.setAttribute("hidden","")})),document.querySelector(`${e.productButtonMoney}[value="${s.id}"]`).removeAttribute("hidden"),document.querySelector(e.productSelectedVariantId).value=s.id,s.available?c(d,u,window.theme.strings.addToCart):i(d,u,window.theme.strings.productSoldOut)}}));const s=document.querySelectorAll(e.accTitles),a=document.querySelectorAll(e.addButton);$(e.container).slick(o),$(e.containerNav).slick(r),a.forEach((e=>{e.addEventListener("click",(e=>{e.preventDefault(),addToCart()}))})),s.forEach((e=>{!function(e){e.addEventListener("click",(e=>{const t=e.currentTarget.nextElementSibling;t.classList.toggle("active"),t.classList.contains("active")?t.style.maxHeight=t.scrollHeight+"px":t.style.maxHeight=0}))}(e)})),window.addToCart=async function(){const t={items:[{id:document.querySelector(e.productSelectedVariantId).value,quantity:1}]};(await fetch(window.Shopify.routes.root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(t)})).ok||console.error("Error:",error),window.theme.drawCart()}},u=()=>{$(e.container).slick("unslick")};!function(e,o){if(void 0!==n[e])throw new Error('Theme Sections: A section of type "'+e+'" has already been registered. You cannot register the same section type twice');function r(e){t.call(this,e,o)}r.constructor=t,r.prototype=Object.create(t.prototype),r.prototype.type=e,n[e]=r}(s,{async onLoad(){d()},onUnload(){u()}})}}()}();